const HAS_PROTOCOL_REGEX = /^(?:[a-z][a-z\d+.-]*:)?\/\//i;

export function ensureExternalUrlProtocol(url: string): string {
  const trimmedUrl = url.trim();

  if (!trimmedUrl || HAS_PROTOCOL_REGEX.test(trimmedUrl)) {
    return trimmedUrl;
  }

  return `https://${trimmedUrl}`;
}
